import TechStacks from "./TechStacks";

const SkilllsContent = () => {

    return (
        <>
            <TechStacks/>
        </>
    );
}

export default SkilllsContent;